"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneratePreviewResponseDto = exports.PreviewPayload = exports.InAppRenderOutput = exports.RedirectTargetEnum = exports.TimeUnitEnum = exports.DelayRenderOutput = exports.DigestOutputProcessor = exports.EmailRenderOutput = exports.PushRenderOutput = exports.SmsRenderOutput = exports.ChatRenderOutput = exports.RenderOutput = void 0;
class RenderOutput {
}
exports.RenderOutput = RenderOutput;
class ChatRenderOutput extends RenderOutput {
}
exports.ChatRenderOutput = ChatRenderOutput;
class SmsRenderOutput extends RenderOutput {
}
exports.SmsRenderOutput = SmsRenderOutput;
class PushRenderOutput extends RenderOutput {
}
exports.PushRenderOutput = PushRenderOutput;
class EmailRenderOutput extends RenderOutput {
}
exports.EmailRenderOutput = EmailRenderOutput;
class DigestOutputProcessor {
    static isDigestRegularOutput(output) {
        if (typeof output !== 'object' || output === null)
            return false;
        const obj = output;
        return typeof obj.amount === 'number' && Object.values(TimeUnitEnum).includes(obj.unit);
    }
    static isDigestTimedOutput(output) {
        if (typeof output !== 'object' || output === null)
            return false;
        const obj = output;
        return typeof obj.cron === 'string' && (typeof obj.digestKey === 'undefined' || typeof obj.digestKey === 'string');
    }
}
exports.DigestOutputProcessor = DigestOutputProcessor;
class DigestRegularOutput {
}
class DigestTimedOutput {
}
class DelayRenderOutput extends RenderOutput {
}
exports.DelayRenderOutput = DelayRenderOutput;
var TimeUnitEnum;
(function (TimeUnitEnum) {
    TimeUnitEnum["SECONDS"] = "seconds";
    TimeUnitEnum["MINUTES"] = "minutes";
    TimeUnitEnum["HOURS"] = "hours";
    TimeUnitEnum["DAYS"] = "days";
    TimeUnitEnum["WEEKS"] = "weeks";
    TimeUnitEnum["MONTHS"] = "months";
})(TimeUnitEnum || (exports.TimeUnitEnum = TimeUnitEnum = {}));
var RedirectTargetEnum;
(function (RedirectTargetEnum) {
    RedirectTargetEnum["SELF"] = "_self";
    RedirectTargetEnum["BLANK"] = "_blank";
    RedirectTargetEnum["PARENT"] = "_parent";
    RedirectTargetEnum["TOP"] = "_top";
    RedirectTargetEnum["UNFENCED_TOP"] = "_unfencedTop";
})(RedirectTargetEnum || (exports.RedirectTargetEnum = RedirectTargetEnum = {}));
class InAppRenderOutput extends RenderOutput {
}
exports.InAppRenderOutput = InAppRenderOutput;
class PreviewPayload {
}
exports.PreviewPayload = PreviewPayload;
class GeneratePreviewResponseDto {
}
exports.GeneratePreviewResponseDto = GeneratePreviewResponseDto;
